import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselViewport,
} from "@loot-os/ui/components/carousel";
import { OpenCard } from "@loot-os/ui/components/open-card";

import type { TopHitsContent } from "../../pages/boxes/content/topHits.js";
import { ClassicPullDialog } from "../ClassicPullDialog.js";

/**
 * The design's "Top Hits": a row of the shopper's best opens that runs past the page's right edge
 * to the screen's, so the cards cut off there read as scrollable.
 */
export function ClassicTopHits({ title, opens }: TopHitsContent) {
  if (opens.length === 0) return null;

  return (
    <section className="flex flex-col gap-3">
      <h2 className="text-lg font-bold tracking-tight text-muted-foreground">{title}</h2>
      <Carousel className="mr-[calc(50%-50vw)]">
        <CarouselViewport>
          <CarouselContent>
            {opens.map((pull) => (
              <CarouselItem key={pull.open.id} className="w-55">
                <ClassicPullDialog pull={pull}>
                  <OpenCard
                    item={pull.open.item}
                    rarityColor={pull.tierColor}
                    badge={pull.tierLabel}
                  />
                </ClassicPullDialog>
              </CarouselItem>
            ))}
          </CarouselContent>
        </CarouselViewport>
      </Carousel>
    </section>
  );
}
